import styled from '@emotion/styled';
import {Link} from 'react-router-dom';

export const CardQuickLinkWrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.xs};
  padding: ${({theme}) => theme.padding.desktop.md};
  text-decoration: none;
`;

export const CardQuickLinkBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  word-break: break-word;
  overflow-wrap: break-word;
`;
